import React from "react";
import { FormattedMessage } from "react-intl";
import { VStack, Button, Box } from "@chakra-ui/react";

import TransactionFilters from "../components/TransactionFilters";
import SettingsIcon from "../components/SettingsIcon";

import { useFlowConfig } from "flows/hooks";

/**
 * <TransactionFilterSection /> Displays list of given selectable filters with a show/hide button.
 * @param {object} props
 * @param {boolean} props.show
 * @param {function} props.onClickFilterButton
 * @param {function} props.onSelect
 * @param {Array<SelectableTransactionFilter>} props.filters
 * @returns {React.ReactElement}
 */
export default function TransactionFiltersSection({
  show: showFilters,
  onClickFilterButton,
  onSelect: toggleTypes,
  filters: types,
}) {
  const { disableTxnHistoryUserFiltering } = useFlowConfig();

  if (`${disableTxnHistoryUserFiltering}` === "true") return null; // integrators can choose to not allow custom user filtering in the UI, using string interpolation to handle bool or string value

  return (
    <VStack align="stretch" background="lighterBackground" padding="17px">
      <Button
        aria-label="Show filter options"
        background={showFilters ? "lighterBackground" : "background"}
        color="secondaryText"
        variant="outline"
        width="fit-content"
        h="32px"
        onClick={() => onClickFilterButton()}
      >
        <SettingsIcon />{" "}
        {!showFilters && (
          <Box ml="7px">
            <FormattedMessage defaultMessage="Filters" description="Label for Filters button" />
          </Box>
        )}
      </Button>
      {showFilters && <TransactionFilters filters={types} onSelect={toggleTypes} />}
    </VStack>
  );
}
